import {
	setServiceUid,
	publicInstance,
	privateInstance,
	basicInstance,
} from './index';
const qs = require('qs');

export const fetchBookableDates = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(`service/${serviceUid}/book/drive-date`, {
			params,
		});
	} catch (error) {
		console.error(error);
	}
};

export const fetchFareTargets = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(
			`service/${serviceUid}/book/fare-target`,
			{
				params,
			},
		);
	} catch (error) {
		console.error(error);
	}
};

export const fetchBusLayout = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await publicInstance().get(
			`service/${serviceUid}/book/bookable-seat`,
			{
				params,
			},
		);
	} catch (error) {
		console.error(error);
	}
};

export const failKcp = async params => {
	try {
		return await basicInstance().delete(
			`service/${params.serviceUid}/fail-kcp`,
			{
				data: qs.stringify(params.params),
				withCredentials: true,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			},
		);
	} catch (error) {
		console.error(error);
	}
};

export const kakaoPay = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await privateInstance().post(
			`service/${serviceUid}/book-kakaopay`,
			params,
		);
	} catch (error) {
		console.error(error);
	}
};

export const failKakaoPay = async params => {
	try {
		return await privateInstance().delete(
			`service/${params.serviceUid}/fail-kakaopay`,
			qs.stringify(params.params),
		);
	} catch (error) {
		console.error(error);
	}
};

export const approveKakaoPay = async params => {
	try {
		return await privateInstance().put(
			`service/${params.serviceUid}/approve-kakaopay`,
			qs.stringify(params.params),
		);
	} catch (error) {
		console.error(error);
	}
};

export const fetchPG = async () => {
	const serviceUid = await setServiceUid();
	try {
		return await privateInstance().get(`service/${serviceUid}/book/pg`);
	} catch (error) {
		console.error(error);
	}
};

export const fetchBookList = async () => {
	const serviceUid = await setServiceUid();
	try {
		return await privateInstance().get(`service/${serviceUid}/book`);
	} catch (error) {
		console.error(error);
	}
};

export const cancelKCP = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await basicInstance().post(
			`service/${serviceUid}/cancel-kcp`,
			qs.stringify(params),
		);
	} catch (error) {
		console.error(error);
	}
};

export const bookFreeTemp = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await privateInstance().post(`service/${serviceUid}/book-temp`, {
			...params.params,
		});
	} catch (error) {
		console.error(error);
	}
};

export const approveBookFree = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await privateInstance().put(
			`service/${serviceUid}/approve-free-temp`,
			qs.stringify(params),
		);
	} catch (error) {
		console.error(error);
	}
};

export const cancelFreeBook = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await privateInstance().delete(`service/${serviceUid}/cancel-free`, {
			data: qs.stringify(params),
			withCredentials: true,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		});
	} catch (error) {
		console.error(error);
	}
};

export const failBookTemp = async params => {
	const serviceUid = await setServiceUid();
	try {
		return await privateInstance().delete(
			`service/${serviceUid}/fail-book-temp`,
			{
				data: qs.stringify(params),
				withCredentials: true,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			},
		);
	} catch (error) {
		console.error(error);
	}
};
